export const getHexadecimal = (alpha: number) =>
  Math.round(255 * (alpha / 100))
    .toString(16)
    .padStart(2, '0');
